import { colors } from '../../colors';
var address = {
  arrowColor: colors.equineStone,
  textColor: colors.equineShadow,
  borderColor: colors.equineSnow,
  backgroundColor: colors.equinePearl
};
export default address;